import api from './api';

export interface UserProfile {
  email: string;
  agencyName: string;
  agencyContactName: string;
  agencyContactPhone: string;
}

// Get user profile
// GET /api/profile
// Response: UserProfile
export const getUserProfile = async (): Promise<UserProfile> => {
  try {
    console.log('Fetching user profile...');
    const response = await api.get('/api/profile');
    console.log('Fetched user profile successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Update user profile
// PUT /api/profile
// Request: Partial<UserProfile>
// Response: UserProfile
export const updateUserProfile = async (data: Partial<UserProfile>): Promise<UserProfile> => {
  try {
    console.log('Updating user profile...', data);
    const response = await api.put('/api/profile', data);
    console.log('Updated user profile successfully');
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', {
      error,
      stack: error.stack
    });
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Change password
// POST /api/profile/change-password
// Request: { currentPassword: string, newPassword: string }
// Response: { message: string }
export const changePassword = async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
  try {
    console.log('Changing password...');
    const response = await api.post('/api/profile/change-password', {
      currentPassword,
      newPassword
    });
    console.log('Password changed successfully');
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};